import React from 'react';
import { useAuthStore } from '../../auth/store';
import InfoBar from './InfoBar';
import { useTranslation } from 'react-i18next';

const TRIAL_DEFAULTS = {
  message: 'This is a trial you cannot save your work',
  expiredMessage: 'Your trial period has expired. Please contact us to continue using the platform.',
  buttonLabel: 'Apply Now!',
  buttonLink: 'https://www.steinbeis-next.de/apply-now/',
  daysLeftPlaceholder: '{DAYS_LEFT}',
};

const TrialBar = () => {
  const { t } = useTranslation();
  const user = useAuthStore((state) => state.user);

  if (!user?.trial?.isTrial) {
    return null;
  }

  const isActive = user.trial.trialActive;
  const baseMessage = isActive
    ? user.trial.message || TRIAL_DEFAULTS.message
    : t('login.errors.trial-expired') || TRIAL_DEFAULTS.expiredMessage;

  const buttonLabel = user.trial.ctaLabel || TRIAL_DEFAULTS.buttonLabel;
  const buttonLink = user.trial.ctaLink || TRIAL_DEFAULTS.buttonLink;

  // Handle trial countdown if applicable
  const daysLeft =
    isActive && user.trial.startdate && user.trial.durationDays
      ? Math.floor(
          (new Date(user.trial.startdate).getTime() + user.trial.durationDays * 24 * 60 * 60 * 1000 - Date.now()) /
            (1000 * 60 * 60 * 24),
        )
      : null;

  const displayMessage =
    daysLeft !== null ? baseMessage.replace(TRIAL_DEFAULTS.daysLeftPlaceholder, daysLeft.toString()) : baseMessage;

  return (
    <InfoBar
      message={displayMessage}
      level={isActive ? 'info' : 'warning'}
      buttonLabel={buttonLabel}
      buttonLink={buttonLink}
      allowDismiss={false}
    />
  );
};

export default TrialBar;
